import React, { useState, useEffect } from "react";
import "./AboutBonk.css";
import { AboutBonkProps } from "../../../models/about-bonk.model";
import { AboutLayers } from "./AboutLayers";
import { AboutContent } from "./AboutContent";
import { AboutModal } from "../../modals/AboutModal";
import { useIntegrationCount } from "../../../hooks/useIntegrationCount";

const AboutBonkPage: React.FC<AboutBonkProps> = ({ offset, isFirstVisit }) => {
	const [showModal, setShowModal] = useState(false);
	const integrationCount = useIntegrationCount();

	// disable background scroll when modal is open
	useEffect(() => {
		const overflowValue = showModal ? "hidden" : "auto";
		document.body.style.overflow = overflowValue;
		document.documentElement.style.overflow = overflowValue;
	}, [showModal]);

	return (
		<div
			className="about-bonk-container"
			style={{ "--offset": offset } as React.CSSProperties}
		>
			<div className={`background-wrapper ${showModal ? "blur" : ""}`}>
				<AboutLayers
					offset={offset}
					isFirstVisit={isFirstVisit}
				/>
				<AboutContent
					offset={offset}
					isFirstVisit={isFirstVisit}
					integrationCount={integrationCount}
					onShowModal={() => setShowModal(true)}
				/>
			</div>

			{showModal && <AboutModal onClose={() => setShowModal(false)} />}
		</div>
	);
};

export default AboutBonkPage;
